import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=bb028f00&"
import script from "./goodList.vue?vue&type=script&lang=js&"
export * from "./goodList.vue?vue&type=script&lang=js&"
import style0 from "./goodList.vue?vue&type=style&index=0&id=bb028f00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports